<app-loading-spinner />
<app-header></app-header>
<app-topbar-menu class="hide-on-mobile" *ngIf="!hideTopBar"></app-topbar-menu>
<app-impersonation-banner></app-impersonation-banner>
<app-scroll-to-top></app-scroll-to-top>
<app-contact-us-modal></app-contact-us-modal>

<app-user-management-create-user-modal></app-user-management-create-user-modal>
<app-product-management-create-product></app-product-management-create-product>
<app-create-password-modal></app-create-password-modal>
<app-reset-password-modal></app-reset-password-modal>
<app-login-modal></app-login-modal>
<app-snackbar></app-snackbar>
<app-add-membership></app-add-membership>
<app-guide-tour-modal></app-guide-tour-modal>

<main class="container">
  <router-outlet></router-outlet>
</main>